module.exports = __webpack_public_path__ + "img/next-arrow.1e5fc475.svg";